export default "__VITE_ASSET__b1a60385__"